import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { ProgressDialog } from '@yola/ws-ui';

const defaultCaptions = {};

function ExportProgressDialog({ captions = defaultCaptions, ...restProps }) {
  const getCaptions = (captionsOverrides) => ({
    title: `${i18next.t('Preparing a ZIP')}.`,
    description: i18next.t('Your site archive will be generated soon'),
    ...captionsOverrides,
  });

  return (
    <ProgressDialog
      overlay="visible"
      progressType="indeterminate"
      cancelable={false}
      captions={getCaptions(captions)}
      {...restProps}
    />
  );
}

ExportProgressDialog.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    cancel: PropTypes.string,
  }),
};

export default ExportProgressDialog;
